import { Link } from 'react-router-dom';

const styles = `
    .industrial-overlay-subtle {
        background: linear-gradient(rgba(18, 18, 20, 0.9), rgba(18, 18, 20, 0.9)), url('https://images.unsplash.com/photo-1555529771-835f59fc5efe?auto=format&fit=crop&q=80&w=2000');
        background-size: cover;
        background-position: center;
    }
    .material-symbols-outlined {
        font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    }
    .prose-custom p {
        @apply mb-6 leading-relaxed text-slate-600 dark:text-slate-400;
    }
    .prose-custom h2 {
        @apply font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-slate-900 dark:text-white mt-12 mb-6;
    }
`;

export const PrivacyPolicy = () => {
    return (
        <>
            <style type="text/tailwindcss">{styles}</style>

            <section
                class="relative py-20 md:py-32 flex items-center overflow-hidden border-b border-slate-200 dark:border-slate-800">
                <div class="absolute inset-0 industrial-overlay-subtle"></div>
                <div class="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
                    <span
                        class="inline-block bg-primary text-white text-xs font-bold px-3 py-1 mb-6 uppercase tracking-[0.3em]">Legal
                        Information</span>
                    <h1 class="text-5xl md:text-7xl font-display font-bold text-white uppercase tracking-tighter mb-4">
                        Privacy <span class="text-primary">Policy</span>
                    </h1>
                    <p class="text-slate-400 font-medium uppercase tracking-widest text-sm">Last Updated: October 2024</p>
                </div>
            </section>
            <main class="py-20 md:py-32 bg-white dark:bg-background-dark">
                <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose-custom">
                    <section class="mb-16">
                        <h2 class="mt-0">Introduction</h2>
                        <p>
                            At Flacon Jeans (owned and operated by Om Clothing Co.), we are committed to protecting your
                            privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you
                            visit our website or interact with our denim manufacturing and retail services.
                        </p>
                        <p>
                            As a heritage-driven brand established in 2007, we understand the importance of trust. Your data
                            security is as vital to us as the quality of the denim we produce in our Maharashtra manufacturing
                            facilities.
                        </p>
                    </section>
                    <section class="mb-16">
                        <h2>Information We Collect</h2>
                        <p>
                            We collect information that you provide directly to us when you make an inquiry, subscribe to our
                            newsletter, or contact us for wholesale opportunities. This may include:
                        </p>
                        <ul class="list-disc pl-6 space-y-4 text-slate-600 dark:text-slate-400 mb-6">
                            <li class="font-medium tracking-tight">Personal identification information (Name, email address,
                                phone number).</li>
                            <li class="font-medium tracking-tight">Business details for B2B wholesale inquiries.</li>
                            <li class="font-medium tracking-tight">Shipping and billing addresses for product fulfillment.</li>
                        </ul>
                        <p>
                            We also automatically collect certain information when you browse our site, including IP addresses,
                            browser types, and usage patterns through cookies and similar tracking technologies to improve your
                            experience.
                        </p>
                    </section>
                    <section class="mb-16">
                        <h2>How We Use Your Data</h2>
                        <p>
                            The data we collect is used primarily to provide and improve our services, including:
                        </p>
                        <ul class="list-disc pl-6 space-y-4 text-slate-600 dark:text-slate-400 mb-6">
                            <li class="font-medium tracking-tight">Processing your manufacturing and product inquiries.</li>
                            <li class="font-medium tracking-tight">Sending updates regarding your orders or collection launches.
                            </li>
                            <li class="font-medium tracking-tight">Analyzing website traffic to optimize our industrial
                                presentation.</li>
                            <li class="font-medium tracking-tight">Ensuring compliance with Indian trade and manufacturing
                                regulations.</li>
                        </ul>
                    </section>
                    <section class="mb-16">
                        <h2>Data Protection</h2>
                        <p>
                            We implement a variety of security measures to maintain the safety of your personal information.
                            Your data is contained behind secured networks and is only accessible by a limited number of persons
                            who have special access rights to such systems and are required to keep the information
                            confidential.
                        </p>
                        <p>
                            All sensitive information is transmitted via Secure Socket Layer (SSL) technology and encrypted into
                            our databases to be accessed only as stated above.
                        </p>
                    </section>
                    <section class="mb-16">
                        <h2>Your Rights</h2>
                        <p>
                            You have the right to request access to the personal data we hold about you, to request that we
                            correct any inaccuracies, and in certain circumstances, to request that we delete your personal
                            data.
                        </p>
                        <p>
                            For any privacy-related requests, please contact our administrative office at Om Clothing Co.,
                            located in Asmeeta Textile Park, Maharashtra.
                        </p>
                    </section>
                    <div class="mt-20 pt-10 border-t border-slate-100 dark:border-slate-800">
                        <Link to="/" class="inline-flex items-center gap-2 text-primary font-bold uppercase tracking-widest text-sm hover:translate-x-2 transition-transform"
                            href="#">
                            <span class="material-symbols-outlined">arrow_back</span>
                            Back to Home
                        </Link>
                    </div>
                </div>
            </main>
        </>
    );
}